import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const setLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return {
    lang: i18n.language,
    setLanguage,
    isLoadingTranslations: false
  };
};
